import { Modal, Form, Input, Button, Row, Col, Select } from "antd";
import { useEffect, useRef, useState } from "react";
import Draggable from "react-draggable";

const { Option } = Select;

const DraggableModal = ({ children, ...props }) => {
  const [disabled, setDisabled] = useState(true);
  const draggleRef = useRef(null);

  return (
    <Modal
      {...props}
      modalRender={(modal) => (
        <Draggable
          disabled={disabled}
          bounds={draggleRef.current ? draggleRef.current : undefined}
          handle=".ant-modal-title"
        >
          <div ref={draggleRef}>{modal}</div>
        </Draggable>
      )}
      title={
        <div
          className="ant-modal-title"
          style={{ width: '100%', cursor: 'move' }}
          onMouseOver={() => setDisabled(false)}
          onMouseOut={() => setDisabled(true)}
        >
          {props.title}
        </div>
      }
    >
      {children}
    </Modal>
  );
};

const AdvanceSearchModal = ({
  visible,
  onCancel,
  onSearch,
  societeOptions,
  selectedCodesoc,
}) => {
  const [form] = Form.useForm();

  const handleSearch = () => {
    form.validateFields().then((values) => {
      onSearch(values);
    });
  };

  const handleReset = () => {
    form.resetFields();
  };

  const validateAgeRange = (_, value) => {
    if (!value) {
      return Promise.resolve();
    }

    const ages = value.split('-').map((age) => parseInt(age.trim(), 10));
    
    if (ages.length !== 2 || isNaN(ages[0]) || isNaN(ages[1])) {
      return Promise.reject(new Error('Veuillez entrer deux âges valides séparés par un tiret.'));
    }

    if (ages[0] > ages[1]) {
      return Promise.reject(new Error('L\'âge minimum doit être inférieur ou égal à l\'âge maximum.'));
    }

    return Promise.resolve();
  };

  useEffect(() => {
    form.setFieldsValue({
     // codesoc: selectedCodesoc || '',
      codebenef: 'A',
    });
  }, [form, selectedCodesoc]);

  
  return (
    <DraggableModal
      open={visible}
      width={1000}
      onCancel={onCancel}
      onOk={handleSearch}
      title="Recherche Avancée"
      maskClosable={false}
      footer={[
        <Button key="reset" onClick={handleReset}>
          Réinitialiser
        </Button>,
        <Button key="search" type="primary" onClick={handleSearch}>
          Rechercher
        </Button>,
      ]}
      headStyle={{ background: "#1890ff", color: "#fff", borderBottom: 0 }}
    >
      <Form form={form} layout="vertical">
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item name="codesoc" label="Société">
              <Select
                showSearch
                bordered={false}
                style={{ borderBottom: "2px solid #030303" }}
                value={selectedCodesoc}
              >
                {societeOptions.map((item) => (
                  <Select.Option key={item.codesoc} value={item.codesoc}>
                    {item.codesoc} {item.societe}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="nom" label="Nom">
              <Input
                bordered={false}
                style={{ borderBottom: "2px solid #030303" }}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="prenoms" label="Prénom">
              <Input
                bordered={false}
                style={{ borderBottom: "2px solid #030303" }}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item name="sexe" label="Sexe">
              <Select
                bordered={false}
                style={{ borderBottom: "2px solid #030303" }}
              >
                <Option value="MA">MA</Option>
                <Option value="FE">FE</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="matribenef" label="Matricule">
              <Input
                bordered={false}
                style={{ borderBottom: "2px solid #030303" }}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="agebenef"
              label="Âge (min - max)"
              rules={[
                {
                  validator: validateAgeRange,
                },
              ]}
            >
              <Input
                placeholder="Ex: 5 - 10"
                bordered={false}
                style={{ borderBottom: "2px solid #030303" }}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
          <Form.Item name="codebenef" label="Type de bénéficiaire" initialValue="A">
              <Select
                bordered={false}
                style={{ borderBottom: "2px solid #030303" }}
              >
                 <Option value="A">Toutes</Option>
                <Option value="2">Epouse</Option>
                <Option value="3">Enfant</Option>
                <Option value="4">Epoux</Option>
                <Option value="5">Ascendant</Option>
                <Option value="6">Autre</Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </DraggableModal>
  );
};

export default AdvanceSearchModal;
